<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">¿PARTICIPA EN LA TOMA DE DECISIONES DE ALGUNA DE ESTAS INSTITUCIONES? (HASTA LOS ÚLTIMOS 2 AÑOS) </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Tiene participación en la toma de decisiones de alguna de estas instituciones? <b-button class="btn-popover" v-b-popover.hover.top="info.decisiones"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de la participación en alguna de estas instituciones de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>¿Participa en la toma de decisiones de alguna institución? <b-button class="btn-popover" v-b-popover.hover.top="info.participante"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="col-md-12 form-group">
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="1" class="d-inline-block">Declarante</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="2" class="d-inline-block">Pareja</p-radio>
            <p-radio name="participante" v-validate="'required'" v-model="form_item.participante" label="3" class="d-inline-block">Dependiente Económico</p-radio>
            <small class="text-danger">{{ errors.first('participante')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Tipo de institución <b-button class="btn-popover" v-b-popover.hover.top="info.tipo"><i class="far fa-question-circle"></i></b-button></label>
            <el-select clearable name="tipo" v-validate="'required'" filterable class="select-default" placeholder="Seleccione una opción" v-model="form_item.tipon_id">
              <el-option v-for="option in tipos_instituciones" class="select-default" :value="option.id" :label="option.valor" :key="option.valor"></el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('tipo')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.tipon_id == 5">
            <label class="control-label">Especifique</label>
            <input class="form-control" type="text" name="especifique" v-validate="'required'" v-model="form_item.especifique" placeholder="Especifique">
            <small class="text-danger">{{ errors.first('especifique')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Nombre de la institución <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre" placeholder="Nombre de la Empresa, Sociedad o Asociación">
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC">
            <small class="text-danger">{{ errors.first('rfc')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Puesto / Rol <b-button class="btn-popover" v-b-popover.hover.top="info.puesto"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="puesto" v-validate="'required'" v-model="form_item.puesto" placeholder="Puesto o rol">
            <small class="text-danger">{{ errors.first('puesto')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Fecha de inicio de participación dentro de la institución <b-button class="btn-popover" v-b-popover.hover.top="info.fecha"><i class="far fa-question-circle"></i></b-button></label>
            <el-date-picker name="fecha" v-validate="'required'" v-model="form_item.fecha" type="date" placeholder="Seleccione fecha" value-format="dd-MM-yyyy" format="dd-MM-yyyy"></el-date-picker>
            <!--  <input class="form-control" type="date" name="fecha" v-validate="'required'" v-model="form_item.fecha" placeholder="fecha"> -->
            <small class="text-danger">{{ errors.first('fecha')}}</small>
          </div>
          <div class="form-group col-6">
          </div>
          <div class="col-6 form-group">
            <label class="control-label"> ¿Recibe remuneración por su participación? <b-button class="btn-popover" v-b-popover.hover.top="info.remunerado"><i class="far fa-question-circle"></i></b-button></label><br>
            <p-radio name="remuneracion" v-validate="'required'" v-model="form_item.remuneracion" label="1" class="d-inline-block">SI</p-radio>
            <p-radio name="remuneracion" v-validate="'required'" v-model="form_item.remuneracion" label="2" class="d-inline-block">NO</p-radio>
            <small class="text-danger">{{ errors.first('remuneracion')}}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.remuneracion=='1'">
            <label class="control-label">Monto mensual neto <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
            <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
            <!--  <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.monto" placeholder="Monto mensual"> -->
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <legend>Lugar donde se ubica <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.pais_id==150">
            <label class="control-label"> Entidad Federativa </label>
            <el-select clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.entidad_federativa_id">
              <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('entidad') }}</small>
          </div>
          <div class="form-group col-md-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <!-- :search="filter" -->
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.participante="{ item }">
                <div>{{filterDeclarante(item.participante)}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  /* import {
    mapState
  } from "vuex"; */
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        bandera: '0',
        ip_id: 1,
        add_item: false,
        edit_item: null,
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Participante',
          value: 'participante',
          align: 'center',
        }, {
          text: 'Nombre de la institución',
          value: 'nombre',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Puesto/rol',
          value: 'puesto',
          align: 'center',
        }, {
          text: 'Fecha',
          value: 'fecha',
          align: 'center',
        }, ],
        info: {
          decisiones: 'Refiere a la condición de pertenencia formal del declarante a alguna institución (Asociación Civil, Consejo y/o Junta, Organizaciones Benéficas, Partidos Políticos, Gremios/Sindicatos u otros) y que cuente con poder de decisión en ella. Deberá reportar hasta los últimos dos años.',
          participante: 'Señalar quien tiene participación en la empresa sociedad o asociación.',
          tipo: 'Señalar del catálogo, alguna de las siguientes: organizaciones de la sociedad civil, organizaciones benéficas, partidos políticos, gremios/sindicatos, otro, especifique.',
          fecha: 'Señalar la fecha en que inicio funciones en la institución u organización.',
          nombre: 'Proporcionar la denominación o razón social de la institución, tal y como se encuentra registrada formalmente.',
          rfc: 'Proporcionar los 12 dígitos del registro de la institución.',
          puesto: 'Indicar el cargo o función que ejerce el Declarante.',
          remunerado: 'Indicar sí o no.',
          monto: 'Especificar el monto mensual neto, sin centavos que percibe por su participación.',
          lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {
      /* ...mapState(["entidades", "paises", "tipos_instituciones"]), */
    },
    watch: {
      /* table_list: {
        handler: function() {
          if (this.table_list) {
            if (this.table_list.length == 0) {
              this.es_beneficiario = "0";
            } else {
              this.es_beneficiario = "1";
            }
          }
        },
        deep: true
      }, */
      /* n_domicilio: {
        handler: function() {
          if (this.n_domicilio) {
            this.form_item.pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.form_item.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.form_item.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.form_item.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.form_item.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.form_item.vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.form_item.vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.form_item.numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.form_item.numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.form_item.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          }
        },
        deep: true
      } */
    },
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;
        }
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("toma_decisiones", this.form_item).then(response => {
                this.StepOk("Guardado");
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("toma_decisiones/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
    },
    created() {
      this.ip_id = this.getKey('uid');
      this.$http.get("toma_decisiones/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      });
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.pais_id = 150;
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/Decisiones.vue